import { userService } from '../_services';
import { router } from '../_helpers';

const user = JSON.parse(localStorage.getItem('user'));

const state = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', { username });

        userService.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', {message: error}, { root: true });
                }
            );
    },
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    refreshToken({ commit, state, dispatch }) {
      userService.refreshToken(state.user.refresh)
        .then(
            access => {
                commit('refreshSuccess', access);
            },
            error => {
                commit('loginFailure', error);
                dispatch('alert/error', {message: error}, { root: true });
            }
          );
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    refreshSuccess(state, newAccess) {
        state.user.token = newAccess
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};